import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import FontAwesomeIcon from './config/FontsAwesome'

import './registerServiceWorker'

createApp(App)
  .component('ic', FontAwesomeIcon)
  .use(store)
  .use(router)
  .mount('#app')
